import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Switch,
  TextField,
  Tooltip,
} from '@mui/material';
import React, {useState} from 'react';
import {useLearnerContext} from '../../context/LearnerContext';
import {actionTypes} from '../../constants/types';
import CreateButton from '../../pages/Learners/components/CreateButton';
import LogoPicker from './LogoPicker';
import {UsersService} from '../../services/users';
import useStore from '../../store/store';
import DialogTitleCustom from '../DialogTitleCustom';
import {ADMIN_COMPANY} from '../../constants/auth';
import EditOrganizationButtons from './editOrganizationButtons';
import {companyConsentText} from '../../constants/organizations';
import {CompanyServices} from '../../services/companies';
import {DatePicker} from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone';

const dayJs = dayjs.extend(utc).extend(timezone);


let CreditslabelAmountUsed=``;


const CreateEditOrganization = ({ type, id, companyName }) => {
  const [open, setOpen] = useState(false);
  const [organisation, setOrganisation] = useState('');
  const [credit, setCredit] = useState('');
  const [contractType, setContractType] = useState('');
  const [conditions, setConditions] = useState('');
  const [remainingCredit, setRemainingCredit] = useState('');
  const [logoFormData, setLogoFormData] = useState(null);
  const { companiesData } = useLearnerContext();
  const [image, setImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const setSnackbarContent = useStore((store) => store.setSnackbarContent);
  const [logoId, setLogoId] = useState('');
  const [isNameDisabled, setIsNameDisabled] = useState(false);

  const [isSuspend, setIsSuspend] = useState(false);
  const [startDate, setStartDate] = useState(() => dayjs());
  const [endDate, setEndDate] = useState(() => dayjs().add(3, 'month'));

  const formItemStyle = {
    marginBottom: '16px',
  };

  const handleReset = () => {
    setOrganisation('');
    setConditions(companyConsentText);
    setCredit('');
    setContractType('monthly');
    setRemainingCredit('');
    setLogoFormData('');
    setImage('');
  };


function setCreditslabelAmountUsed(contract_type,monthly_authorized_credits , contract_credits) {
  const CreditslabelAmountMonthly="Crédits mensuels autorisés";
  let CreditslabelAmountToken=' Tokens à ajouter au crédit ( actuel : ' + monthly_authorized_credits + ' / '+ contract_credits+ ' )' ;
  return (contract_type === 'monthly')
      ? CreditslabelAmountMonthly
      : (contract_type === "date_range_token")
          ? CreditslabelAmountToken
          : '???';
}

  const handleChangeContractType = (data) => {
    setContractType(data.target.value);
    CreditslabelAmountUsed = setCreditslabelAmountUsed(data.target.value,0,0);
 }

  const handleOpen = () => {
    setOpen(true);
    if (type === actionTypes.edit) getCompanyId();
    if (type === actionTypes.create) handleReset();
  };
  const handleClose = () => setOpen(false);

  const createOrganization = async (data) => {
    try {
      await CompanyServices.createCompany(data);
      handleClose();
      companiesData();
    } catch (e) {
      console.log(e);
      setSnackbarContent('error', e?.response?.data?.message || 'Error');
    }
  };

  const downloadLogo = async (imageId) => {
    if (imageId) {
      try {
        setIsImageLoading(true);
        setLogoId(imageId);
        const downloadResponse = await UsersService.downloadAvatar(imageId);

        const blob = new Blob([downloadResponse.data], {
          type: 'application/octet-stream',
        });

        const reader = new FileReader();

        reader.onload = function () {
          const base64String = reader.result.split(',')[1];

          const logo = `data:image/jpeg;base64, ${base64String}`;
          setImage(logo);
        };

        reader.readAsDataURL(blob);
      } catch (e) {
        console.error(e);
        setSnackbarContent('error', 'Erreur due au téléchargement du logo');
      } finally {
        setIsImageLoading(false);
      }
    }
  };


  const getCompanyId = async () => {
    const response = await CompanyServices.getById(id);
    const {
      name,
      monthly_authorized_credits,
      remaining_credits,
      contract_credits,
      contract_type,
      conditions,
      status,
    } = response.data.data;

    const contractStart = response?.data?.data?.contract_start;
    const contractEnd = response?.data?.data?.contract_end;

    setOrganisation(name);
    setIsNameDisabled(name.trim() === ADMIN_COMPANY);
    setCredit((contract_type === 'monthly') ? contract_credits : 0);
    setContractType(contract_type);
    setConditions(conditions);
    setRemainingCredit(remaining_credits);
    setIsSuspend(status === 'temp_active');
    CreditslabelAmountUsed = setCreditslabelAmountUsed(contract_type,monthly_authorized_credits,contract_credits);
    if (contractStart) {
      setStartDate(dayjs(contractStart));
    }
    if (contractEnd) {
      setEndDate(dayJs.utc(contractEnd))
    }
    await downloadLogo(response.data.data?.logo || '');
  };

  const updateOrganization = async (id, updatedData) => {
    console.log("Update company");
    console.log(updatedData);

    try {
      console.log('updateOrganization');
      let old_company_data = await CompanyServices.getById(id);
      console.log('old_company_data');
      console.log(old_company_data);
      if (updatedData.data.contract_type === 'date_range_token') {
          console.log('old_company_data.data.data.monthly_authorized_credits=' + old_company_data.data.data.monthly_authorized_credits);
          updatedData.data.monthly_authorized_credits = Number(old_company_data.data.data.monthly_authorized_credits) + Number(updatedData.data.credit_to_add);
          updatedData.data.contract_credits =  Number(updatedData.data.credit_to_add);
          delete updatedData.data.credit_to_add;
        }
      await CompanyServices.updateCompany(id, updatedData);
      handleClose();
      companiesData();
    } catch (e) {
      console.log(e);
      setSnackbarContent('error', e?.response?.data?.message || 'Error');
    }
  };

  const handleImageUpload = async (event) => {
    const selectedImage = event.target.files[0];

    if (!selectedImage) {
      return;
    }

    const imageURL = URL.createObjectURL(selectedImage);
    setImage(imageURL);

    const reader = new FileReader();
    reader.onload = async (event) => {
      const imageBuffer = event.target.result;

      const formData = new FormData();
      formData.append(
        'file',
        new Blob([imageBuffer], { type: selectedImage.type })
      );

      setLogoFormData(formData);
    };

    reader.readAsArrayBuffer(selectedImage);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let tempLogoId = logoId;

    if (logoFormData) {
      const uploadResponse = await UsersService.uploadAvatar(logoFormData);

      const identifier = uploadResponse.data.identifier;
      tempLogoId = identifier;
    }
    if (type === actionTypes.create) {
      const data = {
        data: {
          name: organisation.trim(),
          contract_credits: credit,
          contract_type: contractType,
          remaining_credits: credit,
          conditions,
          logo: tempLogoId,
          contract_start: startDate,
          contract_end: endDate,
        },
      };
      createOrganization(data);
    }

    if (type === actionTypes.edit) {

      let updatedData = {
        data: {
          name: organisation.trim(),
          monthly_authorized_credits: credit,
          remaining_credits: credit,
          conditions,
          logo: tempLogoId,
          contract_start: startDate,
          contract_end: endDate,
          admin_activation: isSuspend,
          contract_type: contractType,
        },
      };
      if (contractType === 'date_range_token') {
        updatedData = {
          data: {
            name: organisation.trim(),
            credit_to_add : credit,
            conditions,
            logo: tempLogoId,
            contract_start: startDate,
            contract_end: endDate,
            admin_activation: isSuspend,
            contract_type: contractType,
          }
        }

      }


      updateOrganization(id, updatedData);
    }

    setLogoFormData(null);
  };

  return (
    <Box className="align-cell-center">
      {type === actionTypes.create && <CreateButton handleOpen={handleOpen} />}
      {type === actionTypes.edit && (
        <EditOrganizationButtons
          handleOpen={handleOpen}
          companyName={companyName}
        />
      )}
      <Dialog
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitleCustom id="modal-modal-title">
          {type === actionTypes.create
            ? 'Ajouter une organisation'
            : type === actionTypes.edit
            ? 'Modifier une organisation'
            : ''}
        </DialogTitleCustom>
        <DialogContent>
          <form onSubmit={handleSubmit} sx={{ textAlign: 'center' }}>
            <LogoPicker
              image={image}
              handleImageUpload={handleImageUpload}
              isImageLoading={isImageLoading}
            />
            <Tooltip
              title={
                isNameDisabled
                  ? "Le nom de l'organisation administrateur ne peut pas être modifié"
                  : ''
              }
            >
              <TextField
                label="Organisation"
                autoComplete="off"
                type="text"
                disabled={isNameDisabled}
                value={organisation}
                onChange={(e) => setOrganisation(e.target.value)}
                fullWidth
                variant="outlined"
                style={formItemStyle}
              />
            </Tooltip>
            {/** Do NOT REMOVE this comment, will be sed in future enhancement */}
            {/** JPC : uncommented 2025/11/24 */}
            <FormControl style={formItemStyle} fullWidth>
              <InputLabel id="demo-simple-select-label">Type de contrat</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={contractType === "" ? 'monthly' : contractType}
                label="Type de contrat"
                onChange={handleChangeContractType}
              >
                <MenuItem value={"monthly"}>Mensuel</MenuItem>
                <MenuItem value={"date_range_token"}>Plage de dates (par Jeton de 65 car.)</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label={ CreditslabelAmountUsed }
              autoComplete="off"
              type="text"
              value={credit}
              onChange={(e) => {
              let addValue = e.target.value.replace(/[^0-9-]/g, '');
              if (addValue.length > 0) {
                let rest = addValue.length > 1 ? addValue.slice(1) : '';
                addValue = addValue[0] + rest.replace(/[^0-9]/g, '');
              }
                setCredit(addValue);
              }}
              fullWidth
              variant="outlined"
              style={formItemStyle}
            />
            <TextField
              label="Conditions d'utilisation"
              autoComplete="off"
              type="text"
              value={conditions}
              onChange={(e) => setConditions(e.target.value)}
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              style={formItemStyle}
            />
            <DatePicker
              views={['year', 'month']}
              className="full-width "
              label="Début de contrat"
              // minDate={dayjs()}
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              slotProps={{
                popper: {
                  popperOptions: {
                    modifiers: [
                      {
                        name: 'applyCustom',
                        enabled: true,
                        phase: 'beforeWrite',
                        requires: ['computeStyles'],
                        fn: ({ state }) => {
                          state.styles.popper.height = '358px';
                          if (state.placement.includes('top-start')) {
                            state.styles.popper = {
                              ...state.styles.popper,
                              display: 'flex',
                              alignItems: 'flex-end',
                            };
                          }
                          if (state.placement.includes('bottom')) {
                            state.styles.popper = {
                              ...state.styles.popper,
                              display: 'block',
                            };
                          }
                        },
                      },
                    ],
                  },
                },
              }}
            />
            <DatePicker
              views={['year', 'month']}
              className="full-width "
              label="Fin de contrat"
              // minDate={startDate}
              sx={{ mt: 2 }}
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              slotProps={{
                popper: {
                  popperOptions: {
                    modifiers: [
                      {
                        name: 'applyCustom',
                        enabled: true,
                        phase: 'beforeWrite',
                        requires: ['computeStyles'],
                        fn: ({ state }) => {
                          state.styles.popper.height = '358px';
                          if (state.placement.includes('top-start')) {
                            state.styles.popper = {
                              ...state.styles.popper,
                              display: 'flex',
                              alignItems: 'flex-end',
                            };
                          }
                          if (state.placement.includes('bottom')) {
                            state.styles.popper = {
                              ...state.styles.popper,
                              display: 'block',
                            };
                          }
                        },
                      },
                    ],
                  },
                },
              }}
            />
            <Box sx={{ marginTop: '10px' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '-9px',
                }}
              >
                <FormControlLabel
                  className="centered-label"
                  control={<Switch color="primary" />}
                  label="Suspendre"
                  labelPlacement="start"
                  checked={isSuspend}
                  onChange={() => setIsSuspend((prev) => !prev)}
                />
              </Box>
            </Box>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="error">
            Annuler
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CreateEditOrganization;
